module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble"
    }
  }, [_c('h1', {
    staticClass: "plm_hd"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/DEUT_contents"
    }
  }, [_vm._v("Chief abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("NBD – The New Bible Dictionary")]), _vm._v(" (IVP, 2nd edition 1982).")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("neb")]), _vm._v(" – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The New English Bible")]), _vm._v(" (NT 1961, 2nd edition 1970; OT 1970).")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("niv")]), _vm._v(" – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The New International Version")]), _vm._v(" of the Bible (Hodder and Stoughton; 1979, 1984, 2011).")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("nrsv")]), _vm._v(" – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The New Revised Standard Version of the Bible")]), _vm._v(" (NT 1946, 2nd edition 1971; OT 1952, 1989, 1995).")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-574d6091","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/DEUT_abbrev.vue
// module id = 75
// module chunks = 0